import { Box, Checkbox, Text } from '@zillow/constellation-10';
import { type ListingTenantInfoDto as Tenant } from '@zg-rentals/ts-rins-client';

type TenantSelectionProps = {
  tenantList: Array<Tenant>;
  selectedTenants: Array<string>;
  onChange: (tenant: Tenant) => void;
};

type TenantBoxProps = {
  tenant: Tenant;
  isSelected: boolean;
  onChange: (tenant: Tenant) => void;
};

const TenantBox = ({ tenant, isSelected, onChange }: TenantBoxProps) => {
  const { firstName, lastName, email, requestSent } = tenant;
  const name = `${firstName} ${lastName}`;
  return (
    <Box
      key={email}
      style={{
        display: 'flex',
        padding: '12px 16px',
        alignItems: 'flex-start',
        gap: 8,
        borderRadius: 4,
        background: '#fff',
        border: '1px solid #e0e0e0',
        opacity: requestSent ? 0.5 : 1,
        pointerEvents: requestSent ? 'none' : 'auto',
      }}
    >
      <Checkbox
        data-testid="TenantSelection-Checkbox"
        key={email}
        checked={isSelected}
        onChange={() => onChange(tenant)}
        disabled={requestSent}
      />
      <Box data-testid="TenantSelection-Info" style={{ display: 'flex', flexDirection: 'column' }}>
        <Text textStyle="body-bold">{name}</Text>
        {requestSent ? <Text>Request sent</Text> : <Text>{email}</Text>}
      </Box>
    </Box>
  );
};

const TenantSelection = ({ tenantList, selectedTenants, onChange }: TenantSelectionProps) => {
  return (
    <Box style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
      {tenantList.map((tenant) => (
        <TenantBox
          key={tenant.email}
          tenant={tenant}
          isSelected={selectedTenants.includes(tenant.email)}
          onChange={onChange}
        />
      ))}
    </Box>
  );
};

export default TenantSelection;
